import { Divider, Grid } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

import { Text } from '../../../react-components/Text';
import { useAuth } from '../hooks/useAuth';
import { useSessionLoginProvider } from '../hooks/useSessionLoginProvider';
import { StyledLoginButton } from './StyledLoginButton';
import { SocialLoginButtons } from './socialLoginButtons/SocialLoginButtons';

export const Welcome = () => {
  const { setAuthScreen } = useAuth();

  const { run: loginProvider } = useSessionLoginProvider();

  return (
    <>
      <Text
        intlId="auth.welcome"
        variant="h4"
        style={{ marginBottom: `14px`, textAlign: `center`, color: RoutalPalette.primary80 }}
      />

      <Text
        intlId="auth.welcome_subtitle"
        variant="body-large"
        style={{ color: RoutalPalette.secondary00, marginBottom: `24px`, textAlign: `center` }}
      />

      <Grid item container direction="column" gap="10px">
        <StyledLoginButton
          disabled={false}
          intlId="auth.start"
          styleType="primary"
          isEnabled={true}
          onClick={() => {
            setAuthScreen(`login-select-method`);
          }}
          style={{
            margin: 0,
            height: `30px`,
            borderRadius: `4px`,
          }}
        />
        <Divider style={{ backgroundColor: RoutalPalette.neutral10 }} />

        <SocialLoginButtons
          nextStep={(providerToken, provider, accessToken, userName) =>
            loginProvider({ providerToken, provider, accessToken, userName })
          }
        />
      </Grid>
    </>
  );
};
